import { useDispatch, useSelector } from 'react-redux';
import { selectEmployees } from '../../views/employees/reducer';
import { selectCurrentEmployee } from '../../views/tasks/reducer';
import { Fragment, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FaAngleDown } from 'react-icons/fa6';
import { useIntl } from 'react-intl';
import UserGroupPermissions, { addPermissionRefs } from './UserGroupPermissions';
import { deleteTaskInEdit, setCurrentEmployee } from '../../views/tasks/actions';
import { EmployeeDropdownStylized } from './EmployeeDropdownStylized';
import { EmployeeInitialsDropdown } from './EmployeeInitials';
import { fetchEmployees } from '../../views/employees/actions';

interface EmployeeDropdownAndAddButtonProps {
  onAddFunction?: any;
  page?: 'maintenance' | 'daily';
  showAddButton?: boolean;
}

export const EmployeeDropdownAndAddButton = ({
  onAddFunction,
  page = 'daily',
  showAddButton = true,
}: EmployeeDropdownAndAddButtonProps) => {
  const employees = useSelector(selectEmployees);
  const globalEmployee = useSelector(selectCurrentEmployee);
  // This component could have dropdown options in the future
  const hasDropdown = false;
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleAddClick = () => {
    dispatch(deleteTaskInEdit());
    if (onAddFunction) onAddFunction();
  };

  useEffect(() => {
    if (employees.length > 0 && globalEmployee == null) {
      dispatch(setCurrentEmployee(employees[0].id));
    }
  }, [employees]);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, []);

  return (
    <div className={`employee-dropdown-and-add-button ${page}`}>
      <EmployeeDropdownStylized selectedEmployee={globalEmployee} />
      {showAddButton && (
        <UserGroupPermissions itemRef={addPermissionRefs.task}>
          <>
            <button onClick={handleAddClick} className="add-button mobile">
              +
            </button>
            <div className={`add-button-desktop-container${hasDropdown ? ' has-dropdown' : ''}`}>
              <button className="add-button button add" onClick={handleAddClick}>
                {intl.formatMessage({ id: 'addTask' })}
              </button>
              {hasDropdown && (
                <button className="add-button dropdown">
                  <FaAngleDown />
                </button>
              )}
            </div>
          </>
        </UserGroupPermissions>
      )}
    </div>
  );
};
